import CallServer from '../../api/CallServerV2';
import { API_URL_WITHOUT_TENANT } from '../../config/constants';

export async function fetchGetBusinessArea (params = {}) {
    return await CallServer({
        endpoint: `/get_templates_data`,
        withoutTenant: true,
        params: params,
        isGet: true,
        retryIfFailed: true
    })
} 

export async function fetchCreateNewLead ( body = {}) {
    return await CallServer({
        endpoint: `/create_new_demo_lead`,
        withoutTenant: true,
        body: body,
        retryIfFailed: true
    })
} 

export async function fetchCreateNewDemoTenant ( params = {}) {
    return await CallServer({
        endpoint: `/create_new_demo_tenant`,
        withoutTenant: true,
        params: params,
        needAuthenticate: true,
        retryIfFailed: true
    })
} 

export async function fetchRequestContact ( params = {}) {
    return await CallServer({
        endpoint: `/request_admin_contact`,
        params: params,
        needAuthenticate: true,
        retryIfFailed: true
    })
} 